import React, { PropsWithChildren } from "react";
import { IQueryStrictParams } from "../../../../api/entities/page";
import { QueryPropertyType, QueryTypeMap } from "../../../../utils/query-utils";
import { CompactViewScreen } from "../../../shared-ui/common/component-props";
import IOption from "../../../shared-ui/common/option";
import { FiltersBar } from "../../../shared-ui/filters-bar/filters-bar";
import { FiltersBarItem } from "../../../shared-ui/filters-bar/filters-bar-item";
import { ShardClusterFilter } from "./shard-cluster-filter";

export interface IShardClusterAssociatedFilters {
    searchText: string;
    shardClusterFilter: IOption<string>;
}

export const defaultFilters: IShardClusterAssociatedFilters = {
    searchText: null,
    shardClusterFilter: null
};

export const filterNames = {
    searchText: "",
    shardClusterFilter: "Shard Cluster"
};

type SearchPoolFilterParams = Omit<IQueryStrictParams, 'strict'> & {
    pool?: string;
};

export const searchBarStoragePoolFilterTypeMap: QueryTypeMap<SearchPoolFilterParams> = {
    q: QueryPropertyType.String,
    pool: QueryPropertyType.String
}

export interface IShardClusterAssociatedFiltersProps {
    filters: IShardClusterAssociatedFilters;
    onFiltersChange: (filters: Partial<IShardClusterAssociatedFilters>) => void;
    storagePoolOptions: IOption<string>[];
}

export function ShardClusterAssociatedFilters(props: PropsWithChildren<IShardClusterAssociatedFiltersProps>) {

    function handleFilterChange(newFilterValues: Partial<IShardClusterAssociatedFilters>) {
        props.onFiltersChange({ ...props.filters, ...newFilterValues });
    }

    return (
        <FiltersBar
            testId="bucket-filter-bar"
            searchValue={props.filters.searchText}
            onSearchValueChanged={searchText => handleFilterChange({ searchText })}
            compactViewScreen={CompactViewScreen.Medium}
        >

            {!!props.storagePoolOptions && props.storagePoolOptions.length > 0 &&
                <FiltersBarItem>
                    <ShardClusterFilter
                        value={props.filters.shardClusterFilter?.value}
                        onChange={(pool) => handleFilterChange({ shardClusterFilter: { value: pool } })}
                        storagePoolOptions={props.storagePoolOptions}
                    />
                </FiltersBarItem>
            }

            {props.children}

        </FiltersBar>
    );
}
